export default __webpack_public_path__ + "static/interactionfinal-277b145a71d2fe4a0e969f1c360be601.mp4";